function h(e) {
  if (!e)
    return !1;
  const [, t] = e.split("#");
  return t && typeof t == "string" && (t.length === 6 || t.length === 3) && !Number.isNaN(+`0x${t}`);
}
const o = (e) => e != null && e.constructor.name === "Object", i = (e = [], t = []) => {
  const n = new Set(e), r = new Set(t);
  return [...n].filter((c) => !r.has(c));
}, f = (e = [], t = []) => e.every(
  (n) => a(n, t)
), a = (e = {}, t = [], n = []) => {
  const r = Object.keys(e).length !== 0, c = i(t, Object.keys(e)).length === 0, l = !Object.values(e).some(
    (s) => typeof s > "u" || s === ""
  );
  return c && l || !r && l || (() => {
    const s = [];
    return o(e) ? (Object.values(e).forEach((u) => s.push(u)), i(s, n).length === 0) : n.includes(e);
  })();
};
export {
  i as diff,
  f as everyItemOfArrayShouldHave,
  h as isHexColor,
  o as isObject,
  a as validateRequiredFieldsInObject
};
